var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4942 2.29954C12.0202 1.77355 12.0202 0.920261 11.4942 0.394271C10.9683 -0.131352 10.1158 -0.131333 9.58988 0.394271L0.413124 9.57103C0.406554 9.57734 0.399088 9.58311 0.392616 9.58958C0.129525 9.85277 -0.00115148 10.1978 -0.000938258 10.5427C-0.00119925 10.8876 0.12954 11.2326 0.392616 11.4958C0.399058 11.5023 0.406586 11.5081 0.413124 11.5144L9.58988 20.6911C10.1158 21.2169 10.9682 21.2169 11.4942 20.6911C12.0202 20.1652 12.0202 19.3119 11.4942 18.7859L3.25101 10.5427L11.4942 2.29954Z",
    fill: "#615E83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.9960b0eec8aaa770c27c42e1e6689664.svg";
export { ForwardRef as ReactComponent };